import { BaseComponentProps } from "@/types";
import { cn } from "@/lib/utils";

export default function Container({ className, children }: BaseComponentProps) {
  return (
    <div className={cn("w-full px-5 sm:px-6 md:px-[40px] xl:px-[100px] max-w-[1440px] mx-auto", className)}>
      {children}
    </div>
  );
}
